<template>
    <div class="global-address" :class="[isLastUsed ? 'global-address--last-used': '']">
        <div class="global-address__content">
            <small v-if="isLastUsed" class="global-address__last-used">{{ $t('labels.lastUsed') }}</small>
            <address>
                <p v-if="company" class="global-address__company"><strong>{{ company }}</strong></p>
                <p v-if="user" class="global-address__user">{{ user }}</p>
                <p v-if="street" class="global-address__street">{{ street }}</p>
                <p v-if="zipCity" class="global-address__zip-city">{{ zipCity }}</p>
                <p v-if="country" class="global-address__country">{{ country }}</p>
                <p v-if="phone" class="global-address__phone">{{ phone }}</p>
            </address>
        </div>
        <div class="global-address__side-actions">
            <slot name="side-actions" />
        </div>
        <div class="global-address__actions">
            <div class="button-wrapper spaced left spacer--top">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script>
import { countryNameForIso2 } from "@global/utilities/global-country-data";

export default {
    name: "global-address",
    props: {
        lastUsed: false,
        address: {
            type: Object,
        }
    },
    computed:{
        isLastUsed() {
            return this.lastUsed || this.address.lastUsed;
        },
        company() {
            if (!this.address) {
                return false
            }
            return this.address.company ? this.address.company : ''
        },
        user() {
            if (!this.address) {
                return false
            }

            if (this.address.firstName && this.address.lastName) {
                return this.address.firstName + ' ' + this.address.lastName;
            }

            return false
        },
        street() {
            if (!this.address) {
                return false
            }
            return this.address.street ? this.address.street : '';
        },
        zipCity() {
            if (!this.address) {
                return false
            }

            if (this.address.postCode && this.address.city) {
                return this.address.postCode + ' ' + this.address.city;
            }

            return false
        },
        country() {
            if (!this.address) {
                return false
            }

            return this.address.country ? countryNameForIso2(this.address.country) : '';
        },
        phone() {
            if (!this.address || !this.address.phone) {
                return false
            }

            return this.address.phone.length ? this.address.phone : false
        }
    }
}
</script>
